
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m11.2872 3.19529c.2245-.69098 1.2021-.69098 1.4266 0l1.8125 5.57827c.1004.30902.3883.51824.7133.51824h5.8653c.7265 0 1.0286.9297.4408 1.3568l-4.7451 3.4475c-.2629.191-.3729.5295-.2725.8385l1.8125 5.5783c.2245.691-.5663 1.2656-1.1541.8385l-4.7452-3.4475c-.2628-.191-.6188-.191-.8817 0l-4.74511 3.4475c-.58779.4271-1.37865-.1475-1.15413-.8385l1.81249-5.5783c.1004-.309-.00959-.6475-.27246-.8385l-4.74515-3.4475c-.58779-.4271-.28571-1.3568.44083-1.3568h5.86534c.32492 0 .61289-.20922.7133-.51824z","fill":"#ecebea"}})])
          )
        }
      }
    